import { getImageUrl } from "../config/supabase";

const getBookCoverPath = (filename) => `images/book-covers/${filename}`;

// Static book data without the processed URLs
export const currentlyReading = [
  // {
  //   title: "Empire of Silence",
  //   author: "Christopher Ruocchio",
  //   coverImagePath: getBookCoverPath("suneater_1.jpg"),
  //   progress: 1,
  //   goodreadsUrl:
  //     "https://www.goodreads.com/book/show/36454667-empire-of-silence",
  // },https://www.goodreads.com/book/show/49552.The_Stranger
  // {
  //   title: "Abundance",
  //   author: "Ezra Klein",
  //   coverImagePath: getBookCoverPath("abundance.jpg"),
  //   progress: 6,
  //   goodreadsUrl:
  //     "https://www.goodreads.com/book/show/176444106-abundance",
  // },
  {
    title: "Revenge of the Tipping Point",
    author: "Malcolm Gladwell",
    coverImagePath: getBookCoverPath("revenge_of_tipping_point.jpg"),
    progress: 0,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/216857785",
  },
];

// 2026 Reads
export const reads2026 = [
  {
    title: "And Then There Were None",
    author: "Agatha Christie",
    coverImagePath: getBookCoverPath("there_were_none.jpg"),
    rating: 4.5,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/9723667-and-then-there-were-none",
  },
  {
    title: "The Little Prince",
    author: "Antoine de Saint-Exupéry",
    coverImagePath: getBookCoverPath("little_prince.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/157993.The_Little_Prince",
  },
  {
    title: "Where the Red Fern Grows",
    author: "Wilson Rawls",
    coverImagePath: getBookCoverPath("redfern.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/26109063-where-the-red-fern-grows",
  },
  {
    title: "The Stranger",
    author: "Albert Camus",
    coverImagePath: getBookCoverPath("thestranger.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/49552.The_Stranger",
  },
  {
    title: "The Thursday Murder Club",
    author: "Richard Osman",
    coverImagePath: getBookCoverPath("thursday_murder_club.jpg"),
    rating: 3,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/46000520-the-thursday-murder-club",
  },
  {
    title: "To Hold Up the Sky",
    author: "Cixin Liu",
    coverImagePath: getBookCoverPath("to_hold_up_the_sky.jpg"),
    rating: 3,
    goodreadsUrl: "https://www.goodreads.com/book/show/49247266-to-hold-up-the-sky",
  },
  {
    title: "The Secret of Secrets",
    author: "Dan Brown",
    coverImagePath: getBookCoverPath("secret_of_secrets.jpg"),
    rating: 3,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/223889699-the-secret-of-secrets",
  },
  {
    title: "Daredevil: Born Again",
    author: "Frank Miller",
    coverImagePath: getBookCoverPath("daredevil_born_again.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/6929380-daredevil",
  },
  {
    title: "The Idea Factory",
    author: "Jon Gertner",
    coverImagePath: getBookCoverPath("idea_factory.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/11797471-the-idea-factory",
  },
  {
    title: "The Blade Itself",
    author: "Joe Abercombie",
    coverImagePath: getBookCoverPath("blade_itself.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/24958072-the-blade-itself",
  },
  {
    title: "King of Ashes",
    author: "S.A. Cosby",
    coverImagePath: getBookCoverPath("king_of_ashes.jpg"),
    rating: 3,
    goodreadsUrl: "https://www.goodreads.com/book/show/219833252-king-of-ashes",
  },
  {
    title: "Everything is Tuberculosis",
    author: "John Green",
    coverImagePath: getBookCoverPath("tuberculosis.jpg"),
    rating: 5,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/220341389-everything-is-tuberculosis",
  },
  {
    title: "Careless People",
    author: "Sarah Wynn-Williams",
    coverImagePath: getBookCoverPath("careless_people.jpg"),
    rating: 3,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/223436601-careless-people",
  },
  {
    title: "Supergirl: Woman of Tomorrow",
    author: "Tom King",
    coverImagePath: getBookCoverPath("supergirl.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/59854151-supergirl",
  },
  {
    title: "The Amazing Adventures of Kavalier and Clay",
    author: "Michael Chabon",
    coverImagePath: getBookCoverPath("kavalier_and_clay.jpg"),
    rating: 3,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/3985.The_Amazing_Adventures_of_Kavalier_Clay",
  },
  {
    title: "Pachinko",
    author: "Min Jin Lee",
    coverImagePath: getBookCoverPath("pachinko.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/35099568-pachinko",
  },
  {
    title: "Jade Legacy",
    author: "Fonda Lee",
    coverImagePath: getBookCoverPath("jade_legacy.jpg"),
    rating: 4.5,
    goodreadsUrl: "https://www.goodreads.com/book/show/51057191-jade-legacy",
  },
  {
    title: "American Kingpin",
    author: "Nick Bilton",
    coverImagePath: getBookCoverPath("american_kingpin.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/31920777-american-kingpin",
  },
  {
    title: "Jade War",
    author: "Fonda Lee",
    coverImagePath: getBookCoverPath("jade_war.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/41716919-jade-war",
  },
  {
    title: "Piranesi",
    author: "Susanna Clarke",
    coverImagePath: getBookCoverPath("piranesi.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/56268907-piranesi",
  },
];

// 2025 Reads
export const reads2025 = [
  {
    title: "The Hero of Ages",
    author: "Brandon Sanderson",
    coverImagePath: getBookCoverPath("hero_of_ages.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/60784453-the-hero-of-ages",
  },
  {
    title: "Jade City",
    author: "Fonda Lee",
    coverImagePath: getBookCoverPath("jade_city.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/43587154-jade-city",
  },
  {
    title: "Demon Copperhead",
    author: "Barbara Kingsolver",
    coverImagePath: getBookCoverPath("demon_copperhead.jpg"),
    rating: 3,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/60194162-demon-copperhead",
  },
  {
    title: "Dungeon Crawler Carl",
    author: "Matt Dinniman",
    coverImagePath: getBookCoverPath("dungeon_crawler_carl.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/56791389-dungeon-crawler-carl",
  },
  {
    title: "The Well of Ascension",
    author: "Brandon Sanderson",
    coverImagePath: getBookCoverPath("well_of_ascension.jpg"),
    rating: 3,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/68429.The_Well_of_Ascension",
  },
  {
    title: "The Manor of Dreams",
    author: "Christina Li",
    coverImagePath: getBookCoverPath("manor_of_dreams.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/214152076-the-manor-of-dreams",
  },
  {
    title: "Project Hail Mary",
    author: "Andy Weir",
    coverImagePath: getBookCoverPath("project_hail_mary.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/54493401-project-hail-mary",
  },
  {
    title: "The Will of the Many",
    author: "James Islington",
    coverImagePath: getBookCoverPath("will_of_the_many.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/62919748-the-will-of-the-many",
  },
  {
    title: "The Wager: A Tale of Shipwreck, Mutiny, and Murder",
    author: "David Grann",
    coverImagePath: getBookCoverPath("the_wager.jpg"),
    rating: 3,
    goodreadsUrl: "https://www.goodreads.com/book/show/61991807-the-wager",
  },
  {
    title: "Mistborn: The Final Empire",
    author: "Brandon Sanderson",
    coverImagePath: getBookCoverPath("mistborn.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/68428.Mistborn",
  },
  {
    title: "Shadow of the Gods",
    author: "John Gwynne",
    coverImagePath: getBookCoverPath("shadow_gods.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/52694527-the-shadow-of-the-gods",
  },
  {
    title: "The Complete Maus",
    author: "Art Spiegelman",
    coverImagePath: getBookCoverPath("complete_maus.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/15195.The_Complete_Maus",
  },
  {
    title: "The Murder of Roger Ackyord",
    author: "Agatha Christie",
    coverImagePath: getBookCoverPath("roger_ackyord.jpg"),
    rating: 4,
    goodreadsUrl:
      "https://www.goodreads.com/book/show/123387352-the-murder-of-roger-ackyord",
  },
  {
    title: "V for Vendetta",
    author: "Alan Moore",
    coverImagePath: getBookCoverPath("v_for_vendetta.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/5805.V_for_Vendetta",
  },
  {
    title: "Circe",
    author: "Madeline Miller",
    coverImagePath: getBookCoverPath("circe.jpeg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/35959740-circe",
  },
  {
    title: "Recursion",
    author: "Blake Crouch",
    coverImagePath: getBookCoverPath("recursion.jpg"),
    rating: 3,
    goodreadsUrl: "https://www.goodreads.com/book/show/42046112-recursion",
  },
  {
    title: "Yellowface",
    author: "R.F. Kuang",
    coverImagePath: getBookCoverPath("yellowface.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/62047984-yellowface",
  },
  {
    title: "Blink: The Power of Thinking Without Thinking",
    author: "Malcolm Gladwell",
    coverImagePath: getBookCoverPath("blink.jpg"),
    rating: 4,
    goodreadsUrl: "https://www.goodreads.com/book/show/2140.Blink",
  },
];

// Custom hook that combines the static data with Supabase URLs
export function useBookData() {
  const processBookData = (books) => {
    return books.map((book) => ({
      ...book,
      coverImage: getImageUrl(book.coverImagePath),
    }));
  };

  return {
    currentlyReading: processBookData(currentlyReading),
    reads2026: processBookData(reads2026),
    reads2025: processBookData(reads2025),
  };
}
